import * as d3 from 'd3'

function createTitle (dataBus, svg, qnaTextY, aloneTextY) {
    let {
        svgPadding,
        cellHeight
    } = dataBus.graphConfig
    let gTitle = svg.select('.g-title')
    if (gTitle.empty()) {
        gTitle = svg.append('g').attr('class', 'g-title')
            .attr('transform', `translate(${svgPadding},${svgPadding})`)
        gTitle.append('text')
            .attr('id', 'svg-title-qna')
            .attr('class', 'svg-title')
        gTitle.append('text')
            .attr('id', 'svg-title-alone')
            .attr('class', 'svg-title')
    }
    d3.select('#svg-title-qna')
        .text(window.vueapp.$t('qnaText'))
        .attr('transform', `translate(0, ${qnaTextY * cellHeight + cellHeight - 15})`)
    d3.select('#svg-title-alone')
        .text(window.vueapp.$t('aloneText'))
        .attr('transform', `translate(0, ${aloneTextY * cellHeight + cellHeight - 15})`)
}

export default createTitle
